module.exports = __webpack_public_path__ + "media/categories/28-f6bf25ec.svg";